import React, { forwardRef, useMemo, useCallback } from 'react';
import GenericMappingForm from '../GenericMappingForm';
import { Form } from 'antd';

const AppSentinelsMappingForm = forwardRef(function AppSentinelsMappingForm(props, ref) {
  const [form] = Form.useForm();

  const getExtraFieldsData = useCallback((config) => {
    const { organization, application } = config;
    return {
      organization,
      application,
    };
  }, []);

  const extraFields = useMemo(() => ([
    {
      name: 'organization',
      colSpan: 10,
      label: 'Organization',
      help: 'Findings are fetched based on the Organization and Application name specified. Please enter the exact organization and application name as specified in AppSentinels.',
      required: true,
      props: {
        autoFocus: true
      }
    }, {
      name: 'application',
      colSpan: 10,
      label: 'Application',
      help: 'Findings are fetched based on the Organization and Application name specified. Please enter the exact organization and application name as specified in AppSentinels.',
      required: true
    },
  ]), []);
  return (
    <GenericMappingForm
      ref={ref}
      {...props}
      form={form}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
    />
  )
})

export default AppSentinelsMappingForm;